import { Button, EmojiPicker } from '@affine/component';
import { useI18n } from '@affine/i18n';
import { cssVarV2 } from '@toeverything/theme/v2';

export interface TagEmojiPickerProps {
  /** `undefined` means "remove the emoji". */
  onSelect?: (emoji?: string) => void;
  onClose?: () => void;
}

export const TagEmojiPicker = ({ onSelect }: TagEmojiPickerProps) => {
  const t = useI18n();
  return (
    <div
      style={{
        width: 360,
        maxWidth: '100%',
        height: 360,
        display: 'flex',
        flexDirection: 'column',
        padding: 8,
        boxSizing: 'border-box',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="plain"
          style={{ color: cssVarV2.text.secondary, fontWeight: 500 }}
          onClick={() => onSelect?.()}
        >
          {t['com.affine.iconPicker.remove']()}
        </Button>
      </div>
      {/* The emoji list scrolls in a flex child with `height: 0`, so it needs a sized parent. */}
      <div style={{ height: 0, flexGrow: 1 }}>
        <EmojiPicker onSelect={emoji => onSelect?.(emoji)} />
      </div>
    </div>
  );
};
